import { render, staticRenderFns } from "./ContentTypeComponent.vue?vue&type=template&id=7b62a1a7&scoped=true"
import script from "./ContentTypeComponent.vue?vue&type=script&lang=js"
export * from "./ContentTypeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b62a1a7",
  null
  
)

export default component.exports